<template>
    <div class="text-editor">
        <div ref="type" class="text-editor-wrapper">
            <div ref="codeMirrorEditor"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onUnmounted, onMounted } from "vue";
import { defaultKeymap } from "@codemirror/commands";
import { StreamLanguage } from "@codemirror/language";
import { gherkin } from "@codemirror/legacy-modes/mode/gherkin";
import { EditorState as CodeMirrorState } from "@codemirror/state";
import { EditorView as CodeMirrorView, keymap } from "@codemirror/view";
import { basicSetup } from "codemirror";
import { Artefact } from "@/lib/artefacts";

const artefact = defineModel<Artefact>({ required: true });
const editor = ref<CodeMirrorView>();
const codeMirrorEditor = ref<HTMLDivElement>();

const initCodeMirror = () => {
    const trackChanges = CodeMirrorState.transactionExtender.of((tr) => {
        if (tr.docChanged) {
            artefact.value.content = tr.newDoc.toString();
        }
        return {};
    });
    const extensions = [
        basicSetup,
        trackChanges,
        keymap.of(defaultKeymap),
        CodeMirrorView.contentAttributes.of({ spellcheck: "true" }),
        CodeMirrorView.lineWrapping,
        StreamLanguage.define(gherkin),
    ];
    editor.value = new CodeMirrorView({
        state: CodeMirrorState.create({
            doc: artefact.value.content,
            extensions,
        }),
        parent: codeMirrorEditor.value,
    });
};

onMounted(() => {
    initCodeMirror();
});

onUnmounted(() => {
    editor.value?.destroy?.();
});
</script>

<style lang="scss" scoped>
.text-editor-wrapper {
    display: flex;
    flex-direction: column;

    > * {
        flex: 1;
    }
}
</style>
